import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { FieldText } from "../FieldText";
import { FieldNumber } from "../FieldNumber";
import { FieldDate } from "../FieldDate";
import { FieldList } from "../FieldList";
import * as API from "../../api";
import { FieldCheckbox } from "../FieldCheckbox";
import { FieldListSearch } from "../FieldListSearch";

export const RegistroComprometido = ({
  metadataTable,
  setMetadataTable = () => {},
  comprometido,
  setComprometido = () => {},
  edit = false,
  create = false,
  lists,
  area,
}) => {
  const [listsProps, setListsProps] = useState(lists);
  const [comprometidoEdit, setComprometidoEdit] = useState(comprometido);

  useEffect(() => {
    if (comprometido && Object.hasOwn(comprometido, "CodigoProveedor")) {
      const data = {
        codigo: comprometido.CodigoProveedor,
        idArea: area.value,
      };

      const newListsProps = structuredClone(listsProps);
      newListsProps.TipoFacturable.value = {
        Valor: comprometido.TipoFacturable,
        Etiqueta: comprometido.TipoFacturable,
      };

      API.obtenerListaAreasProveedor(data)
        .then((res) => {
          newListsProps.AreaProveedor = {
            Lista: "AreaProveedor",
            Valores: res.CodigosAreaProveedor,
            value: {
              Valor: comprometido.AreaProveedor,
              Etiqueta: comprometido.AreaProveedor,
            },
          };

          const newMetadataTable = structuredClone(metadataTable);
          newMetadataTable.forEach((e) => {
            if (e.nombreCampo === "AreaProveedor") {
              e.requerido = res.CodigosAreaProveedor.length > 0;
            }
          });
          setMetadataTable(newMetadataTable);
        })
        .catch((error) => console.error(error))
        .finally(() => setListsProps(newListsProps));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (key, value) => {
    const newValues = { ...comprometidoEdit };
    newValues[key] = value;

    if (key === "Proveedor") {
      const codigoProveedor = value.Valor;
      newValues.CodigoProveedor = codigoProveedor;
      newValues.AreaProveedor = "";
      if (codigoProveedor) getListAreaProveedor(codigoProveedor);
    }

    setComprometidoEdit(newValues);
    setComprometido(newValues);
  };

  const getListAreaProveedor = (codigoProveedor) => {
    const data = {
      codigo: codigoProveedor,
      idArea: area.value,
    };
    API.obtenerListaAreasProveedor(data)
      .then((res) => {
        const newListsProps = structuredClone(listsProps);
        newListsProps.AreaProveedor = {
          Lista: "AreaProveedor",
          Valores: res.CodigosAreaProveedor,
        };
        setListsProps(newListsProps);

        const newMetadataTable = structuredClone(metadataTable);
        newMetadataTable.map((e) => {
          if (e.nombreCampo === "AreaProveedor") {
            e.requerido = res.CodigosAreaProveedor.length > 0;
          }
          return e;
        });
        setMetadataTable(newMetadataTable);
      })
      .catch((error) => console.error(error));
  };

  const handleChangeCheckbox = (key, value) => {
    const newValues = { ...comprometidoEdit };
    newValues[key] = value ? "SI" : "NO";
    setComprometidoEdit(newValues);
    setComprometido(newValues);
  };

  const handleListChange = (key, value) => {
    const metadata = metadataTable.find((m) => m.nombreLista === key);
    const newValues = { ...comprometidoEdit };

    newValues[metadata.nombreCampo] = value?.Valor;

    if (key === "SociedadAuxiliar") {
      newValues.CodigoSociedad = value.Valor;
    }

    const tmpListsProps = { ...listsProps };
    tmpListsProps[key].value = value;

    if (!metadata.listaRelacional) {
      if (metadata.campoAux) {
        newValues[metadata.campoAux] = value?.Valor;
      }
      setListsProps(tmpListsProps);
      setComprometidoEdit(newValues);
      setComprometido(newValues);
    } else {
      if (metadata.nombreLista === "Familia") {
        const data = { familia: value.Valor, idArea: area?.value };
        API.obtenerConceptoPorFamilia(data).then((res) => {
          tmpListsProps[metadata.listaRelacional] = {
            Lista: metadata.listaRelacional,
            Valores: res,
          };
          setComprometidoEdit(newValues);
          setComprometido(newValues);
          setListsProps(tmpListsProps);
        });
      } else {
        const dataSend = {
          Lista: metadata.listaRelacional,
          ListaRelacional: {
            NombreLista: metadata.nombreLista,
            IdEntidadRelacional: value.Valor,
          },
        };
        API.obtenerLista(dataSend).then((res) => {
          tmpListsProps[metadata.listaRelacional] = res;
          setListsProps(tmpListsProps);
          setComprometidoEdit(newValues);
          setComprometido(newValues);
        });
      }
    }

    if (key === "TipoCarga") {
      const newMetadataTable = structuredClone(metadataTable).map((e) => {
        if (e.nombreCampo === "IDPrinex") {
          if (value.Valor === "Activo" || value.Valor === "Prestamo") {
            e.requerido = true;
            e.editable = true;
          } else {
            e.requerido = false;
            e.editable = false;
          }
        }
        return e;
      });
      setMetadataTable(newMetadataTable);
    }
  };

  const convertOptions = (options) =>
    options.map(({ Valor: value, Etiqueta: label }) => ({
      value,
      label,
    }));

  const convertOption = ({ Valor: value, Etiqueta: label }) => ({
    value,
    label,
  });

  return (
    <S.Wrapper>
      {metadataTable.map((field) => {
        const idField = field.nombreCampo;
        const defaultValue = field.defaultValue;
        const value = comprometidoEdit
          ? comprometidoEdit[field.nombreCampo]
          : "";
        let editable =
          (!comprometido || comprometido.PermiteEditar) &&
          ((create && !field.readOnly) || (edit && field.editable)) &&
          (!field.campoDependiente ||
            (comprometidoEdit &&
              field.campoDependiente in comprometidoEdit &&
              comprometidoEdit[field.campoDependiente] !== undefined));

        if (
          edit &&
          !editable &&
          comprometido &&
          comprometido.PermiteEditarImporteBaja &&
          idField === "ImporteRevisado"
        ) {
          editable = true;
        }

        const required = field.requerido;
        const etiqueta =
          required && editable ? "* " + field.etiqueta : field.etiqueta;
        const lista = field.nombreLista;
        const type =
          !editable && field.tipo === "checkbox" ? "text" : field.tipo;
        if (type === "list" && edit && comprometido && listsProps[lista]) {
          listsProps[lista].value = {
            Valor: comprometido[idField],
            Etiqueta: comprometido[idField],
          };
        }

        if (
          idField === "IDPrinex" &&
          field.campoDependiente &&
          listsProps[field.campoDependiente]?.value?.Valor === "Servicio"
        ) {
          editable = false;
        }
        switch (type) {
          case "int":
          case "float":
            return (
              <FieldNumber
                key={idField}
                id={idField}
                label={etiqueta}
                value={value || 0}
                empty={value === "" || value === null}
                handleChange={handleChange}
                type={type}
                readOnly={!editable}
                required={required && editable}
                styles="filter"
                titleWeight="semibold"
              />
            );

          case "date":
            return (
              <FieldDate
                key={idField}
                id={idField}
                label={etiqueta}
                value={value?.split("T")[0] || ""}
                handleChange={handleChange}
                readOnly={!editable}
                required={required && editable}
                styles="filter"
                titleWeight="semibold"
              />
            );

          case "list":
            return (
              <FieldList
                key={idField}
                id={lista}
                label={etiqueta}
                field={field}
                currentOption={
                  (listsProps[lista]?.value &&
                    convertOption(listsProps[lista]?.value)) || { value: "" }
                }
                options={
                  listsProps[lista]?.Valores
                    ? convertOptions(listsProps[lista]?.Valores)
                    : []
                }
                handleChange={handleListChange}
                isClearable={listsProps[lista]?.MostrarVacio || false}
                readOnly={!editable}
                type={"enum"}
                titleWeight="semibold"
              />
            );

          case "checkbox":
            return (
              <FieldCheckbox
                key={idField}
                id={idField}
                label={etiqueta}
                field={field}
                defaultValue={defaultValue}
                value={value === "SI"}
                handleChange={handleChangeCheckbox}
                readOnly={!editable}
                titleWeight="semibold"
              />
            );

          case "relate":
            return (
              <FieldListSearch
                key={idField}
                id={idField}
                label={etiqueta}
                listName={lista}
                currentOption={
                  comprometidoEdit
                    ? {
                        value: comprometidoEdit[idField]?.Valor || "",
                        label: comprometidoEdit[idField]?.Etiqueta || "",
                      }
                    : { value: "" }
                }
                handleChange={handleChange}
                readOnly={!editable}
                required={required && editable}
                parent={field.parent}
                idParent={area.value}
                titleWeight="semibold"
              />
            );

          case "text":
          default:
            return (
              <S.Column key={field.nombreCampo} $span={field.colSpan}>
                <FieldText
                  key={idField}
                  id={idField}
                  label={etiqueta}
                  value={value || ""}
                  handleChange={handleChange}
                  readOnly={!editable}
                  required={required && editable}
                  styles="accordion"
                  showTooltip
                  titleWeight="semibold"
                />
              </S.Column>
            );
        }
      })}
    </S.Wrapper>
  );
};

RegistroComprometido.propTypes = {
  metadataTable: PropTypes.array,
  setMetadataTable: PropTypes.func,
  movimiento: PropTypes.object,
  listas: PropTypes.object,
  type: PropTypes.string,
  handleSelectionChange: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  setLoading: PropTypes.func,
  access: PropTypes.object,
  area: PropTypes.object,
};
